module.exports = __webpack_public_path__ + "assets/32013f3286ab2a4cbb51c98d545698da.mp3";